import { MedicalRecord } from '../types/medical-record';

export const defaultMedicalRecord: MedicalRecord = {
  anamnesis: '',
  cid: [{ id: null, statusId: null, name: '' }],
  tuss: [{ id: null, name: '' }],
  outcomeId: null,
  links: [],
  additionalSummaryNotes: '',
};
